import { normalizarDocumento } from "./documento.js";

/**
 * Helpers para acessar campos da empresa tolerando diferentes formatos
 * do backend (camelCase, snake_case, variações semânticas).
 *
 * Replica o contrato usado no CadastroEmpresa para que o Acompanhamento
 * deste projeto consiga ler respostas de qualquer um dos dois backends.
 */

const CAMPOS_NOME = [
  "razao_social",
  "razaoSocial",
  "razaosocial",
  "nome_fantasia",
  "nomeFantasia",
  "nome",
  "NOME",
  "RAZAO_SOCIAL",
];

const CAMPOS_DOCUMENTO = [
  "cnpj",
  "CNPJ",
  "cpf",
  "CPF",
  "documento",
  "documento_fiscal",
  "DOCUMENTO",
];

const CAMPOS_ID = [
  "id",
  "ID",
  "id_empresa",
  "empresa_id",
  "idEmpresa",
  "ID_EMPRESA",
];

const CHAVES_LISTA_RESPOSTA = [
  "data",
  "rows",
  "results",
  "empresas",
  "items",
  "itens",
];

export function obterIdEmpresa(empresa) {
  if (!empresa || typeof empresa !== "object") return null;

  const idValido = CAMPOS_ID.map((campo) => empresa[campo]).find(
    (valor) => Number.isInteger(Number(valor)) && Number(valor) > 0,
  );

  return idValido ? Number(idValido) : null;
}

export function obterNomeEmpresa(empresa) {
  if (!empresa || typeof empresa !== "object") return "";

  const encontrado = CAMPOS_NOME.map((campo) => empresa[campo]).find((valor) =>
    String(valor || "").trim(),
  );

  return String(encontrado || "").trim();
}

export function obterDocumentoEmpresa(empresa) {
  if (!empresa || typeof empresa !== "object") return "";

  const encontrado = CAMPOS_DOCUMENTO.map((campo) => empresa[campo]).find(
    (valor) => String(valor || "").trim(),
  );

  return String(encontrado || "").trim();
}

/** Resolve o "objeto empresa" dentro de diferentes formatos de payload. */
export function normalizarEmpresaResposta(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return null;
  }

  const chavesDiretas = ["data", "item", "empresa", "result", "cadastro"];
  for (const chave of chavesDiretas) {
    const candidato = payload[chave];
    if (candidato && typeof candidato === "object") return candidato;
  }
  return payload;
}

export function normalizarListaEmpresas(payload) {
  if (Array.isArray(payload)) return payload;

  if (payload && typeof payload === "object") {
    for (const chave of CHAVES_LISTA_RESPOSTA) {
      if (Array.isArray(payload[chave])) return payload[chave];
    }
  }
  return [];
}

export function empresaCorrespondeDocumento(empresa, documentoDigitado) {
  if (!empresa || typeof empresa !== "object") return false;

  const docLimpo = normalizarDocumento(documentoDigitado);
  if (!docLimpo) return false;

  return CAMPOS_DOCUMENTO.some((campo) => {
    const valor = empresa[campo];
    if (typeof valor !== "string") return false;
    return valor.replace(/\D/g, "") === docLimpo;
  });
}

export function encontrarEmpresaCorreta(dados, documentoDigitado) {
  if (Array.isArray(dados)) {
    return (
      dados.find((item) => empresaCorrespondeDocumento(item, documentoDigitado)) ||
      null
    );
  }

  if (dados && typeof dados === "object") {
    if (empresaCorrespondeDocumento(dados, documentoDigitado)) return dados;

    for (const chave of CHAVES_LISTA_RESPOSTA) {
      if (Array.isArray(dados[chave])) {
        const encontrada = dados[chave].find((item) =>
          empresaCorrespondeDocumento(item, documentoDigitado),
        );
        if (encontrada) return encontrada;
      }
    }
  }

  return null;
}

export function montarDescricaoEmpresa(empresaRef) {
  if (!empresaRef) return "Empresa não identificada";

  const nome = String(empresaRef.nome || "").trim();
  const documento = String(empresaRef.documento || "").trim();

  if (nome && documento) return `${nome} - ${documento}`;
  if (nome) return nome;
  if (documento) return documento;
  if (empresaRef.id) return `Empresa #${empresaRef.id}`;
  return "Empresa não identificada";
}
